import {
    BufferGeometry,
    Mesh,
    MeshBasicMaterial,
    NormalBufferAttributes,
    Object3DEventMap,
    ShaderMaterial,
    Vector3
} from "three";
import {CameraModel} from "features/apartmentViewer/ApartmentViewer/models/CameraModel";
import {PanoramaModel} from "features/apartmentViewer/ApartmentViewer/models/PanoramaModel";

export class MarkerModel {
    public id: string;
    public position: Vector3;
    public rotation: Vector3;
    public isVisible: boolean;
    public model:  Mesh<BufferGeometry<NormalBufferAttributes>, (ShaderMaterial | MeshBasicMaterial)[], Object3DEventMap>;
    public camera: CameraModel;
    public isHovered: boolean = false;

    constructor(cameraId: string, position: Vector3, rotation: Vector3, model: Mesh<BufferGeometry<NormalBufferAttributes>, (ShaderMaterial | MeshBasicMaterial)[], Object3DEventMap>, cameraConfig: CameraModel) {
        this.id = cameraId;
        this.position = position;
        this.rotation = rotation;
        this.isVisible = true;
        this.model = model;
        this.camera = cameraConfig;
        this.model.position.copy(this.position);
        this.model.rotation.set(this.rotation.x, this.rotation.y, this.rotation.z);
    }


    setIsVisible(panoramaModel: PanoramaModel) {
        const directionToCamera = new Vector3().subVectors(this.model.position, panoramaModel.position);

        const distanceToCamera = panoramaModel.position.distanceTo(this.model.position);
        const depthThreshold = panoramaModel.depthManager.getDepth(directionToCamera);

        this.isVisible = distanceToCamera < depthThreshold;

        return this.isVisible;
    }

    update() {
        if (this.isHovered) {
            (this.model.material as ShaderMaterial[])[0].uniforms.isHovered.value = true;
        } else {
            (this.model.material as ShaderMaterial[])[0].uniforms.isHovered.value = false;
        }
    }
}
